import throttle from 'lodash/throttle'
// import 'animation.gsap'
import { TweenMax, TimelineMax, gsap } from 'gsap' // Also works with TweenLite and TimelineLite
// import 'debug.addIndicators'
import ScrollMagic from 'ScrollMagic'

const $paginationTop = $('.technology-items-pagination ol')
const $counter = $('.technology-items-counter ol')
const $images = $('.technology-list-images ol')

const fn = {
  init: () => {
    if (window.matchMedia('(min-width: 768px) and (min-height: 768px)').matches) {
      fn.setupHorizontalList()

      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 150)
    } else {
      fn.setupVerticalList()
    }
  },

  setupVerticalList: () => {
    const $icons = $('.technology-panel__icon')

    const handleScroll = () => {
      const viewportCenter = window.innerHeight / 2
      let $closest = null
      let closestCenter = 9999

      $icons.each((_, el) => {
        const rect = el.getBoundingClientRect()
        const center = Math.abs(rect.top + rect.height / 2)
        const diff = Math.abs(viewportCenter - center)

        if (diff < closestCenter) {
          $closest = $(el)
          closestCenter = diff
        }
      })

      if ($closest) {
        $('.technology-panel__icon.is-active').removeClass('is-active')

        $closest.addClass('is-active')
      }
    }

    $(window).on('scroll', throttle(handleScroll, 250))

    handleScroll()
  },

  setupHorizontalList: () => {
    const controller = new ScrollMagic.Controller()

    const wipeAnimation = new TimelineMax()
      .to('.technology-list-items', 1, {
        x: '-25%',
        onStart: () => {
          fn.setActiveSlide(2)
        },
        onReverseComplete: () => {
          fn.setActiveSlide(1)
        },
      })
      .to('.technology-list-items', 1, {
        x: '-50%',
        onStart: () => {
          fn.setActiveSlide(3)
        },
        onReverseComplete: () => {
          fn.setActiveSlide(2)
        },
      })
      .to('.technology-list-items', 1, {
        x: '-75%',
        onStart: () => {
          fn.setActiveSlide(4)
        },
        onReverseComplete: () => {
          fn.setActiveSlide(3)
        },
      })

    const scene = new ScrollMagic.Scene({
      triggerElement: '#scroll-pin',
      triggerHook: 'onLeave',
      duration: '400%',
    })
      .setPin('#scroll-pin')
      .setTween(wipeAnimation)
      // .addIndicators()
      .addTo(controller)

    controller.scrollTo(function (newScrollPos) {
      $('html, body').animate({ scrollTop: newScrollPos })
    })

    $paginationTop.find('li').on('click', function () {
      const index = $(this).data('index')

      if (index === 1) {
        controller.scrollTo(0)
      } else {
        let additionalOffset = index * 15

        if (window.matchMedia('(min-width: 1024px)').matches) {
          additionalOffset = index * 25
        }

        if (window.matchMedia('(min-width: 1200px)').matches) {
          additionalOffset = index * 35
        }

        if (window.matchMedia('(min-width: 1440px)').matches) {
          additionalOffset = index * 45
        }

        controller.scrollTo((index - 1) * (window.innerHeight + window.innerHeight / 4) + additionalOffset)
      }
    })
  },

  setActiveSlide: (index) => {
    $paginationTop.find('.is-active').removeClass('is-active')
    $paginationTop.find(`li:eq(${index - 1})`).addClass('is-active')

    $counter.find('.is-active').removeClass('is-active')
    $counter.find(`li:eq(${index - 1})`).addClass('is-active')

    $images.find('.is-active').removeClass('is-active')
    $images.find(`li:eq(${index - 1})`).addClass('is-active')
  },
}

export default {
  can: () => document.body.classList.contains('pagetype-technologypage'),
  run: fn.init,
}
